import { Navigate, useLocation } from "react-router-dom";
import { hasCompletedRegimeSelection } from "./tdsStorage";
import { TDS_START_PATH } from "./tdsNavConfig";

/**
 * Redirects to regime selection until the user completes Step 1.
 */
export default function TdsWorkspaceGuard({ children }) {
  const location = useLocation();

  if (!hasCompletedRegimeSelection() && !location.pathname.endsWith("/start")) {
    return <Navigate to={TDS_START_PATH} replace />;
  }

  return children;
}
